import React, { useState } from "react";
import CertificateView from "./CertificateView";
import "../assets/css/verify.css";

const Verify = () => {
  const [certificateId, setCertificateId] = useState("");
  const [certificateData, setCertificateData] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    const trimmedId = certificateId.trim();

    if (!trimmedId) {
      alert("Enter certificate number");
      return;
    }

    setLoading(true);
    setResult(null);
    setCertificateData(null);

    try {
      const res = await fetch(
        `https://icaglobal.in/verify-api.php?id=${encodeURIComponent(trimmedId)}`
      );

      if (!res.ok) {
        throw new Error("Server error");
      }

      const data = await res.json();

      if (data.valid) {
        setResult("valid");
        setCertificateData(data.data);
      } else {
        setResult("invalid");
      }

    } catch (err) {
      console.error("Verification error:", err);
      setResult("invalid");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verify-page">

      <section className="verify-hero">
        <div className="container" style={{ textAlign: "center" }}>
          <h1>Verify Certificate</h1>
          <p>Enter certificate number to verify</p> 
        </div>
      </section>

      <div className="verify-box container" style={{ textAlign: "center" }}>
        <input
          type="text"
          placeholder="Enter certificate number"
          value={certificateId}
          onChange={(e) => setCertificateId(e.target.value)}
        />

        <button onClick={handleVerify} disabled={loading}>
          {loading ? "Verifying..." : "Verify"}
        </button>

        {result === "invalid" && (
          <p style={{ color: "red", marginTop: 20 }}>
            Invalid Certificate Number
          </p>
        )}
      </div>

      {result === "valid" && certificateData && (
        <CertificateView data={certificateData} />
      )}

    </div>
  );
};

export default Verify;